import { isEmpty } from 'lodash';
import { ActionButton } from '../../components/vertical-dot/popper';
import { TableBodyCellColumn, TableBodyCellColumnCenter } from '../style/table.styled';
import { Display } from '../style/common.styled';
import Tag from '../../components/lozenge/tags';
import moment from 'moment';
import { DATE_FORMAT } from '../common';

const TENANT_STATE_LOCKED = 'Locked';

enum InitializationStatus {
  Initializing = 'Initializing',
  Initialized = 'Initialized',
  Failed = 'InitializationFailed ',
}

enum SandboxVisibility {
  Private = 'Private',
  Public = 'Public',
}

export const SwitchSandboxHeader = ({
  actions,
  tableActions,
}: {
  actions: any;
  tableActions: any;
}): any[] => {
  const newActions = [
    ...(actions || []),
    {
      accessor: 'actions',
      width: 20,
      sortable: false,
      isSubHeader: false,
      renderCell: true,
      Cell: ({ row }: any) => {
        let finalActions = [...tableActions];
        if (row.original.tenantState === TENANT_STATE_LOCKED) {
          finalActions = finalActions.filter(
            (action: any) =>
              action.id === 'changeStatusAction'
          );
        } else {
          if (row.original.initializationStatus === InitializationStatus.Initializing) {
            finalActions = finalActions.filter((action: any) => action.as === 'Edit');
          }
          if (row.original.visibility === SandboxVisibility.Private) {
            finalActions = finalActions.filter(
            (action: any) => action.id !== 'loadToMainAction'
          );
        } else {
          finalActions = finalActions.filter(
              (action: any) => action.id !== 'shareAction' && action.id !== 'convertToPublicAction'
            );
          }
        }
        return (
          <td>
            {!row.original?.isDeleteProcessing && (
              <ActionButton
                actions={finalActions}
                id={row.original.tenantId}
                rowData={row.original}
                counter={parseInt(row?.tenantId)}
              />
            )}
          </td>
        );
      },
    },
  ];

  return newActions;
  return [
    {
      Header: 'Name',
      accessor: 'name',
      width: 150,
      sortable: true,
    },
    {
      Header: 'Description',
      accessor: 'description',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn className=''>
            <div className='cellTitle '>
              {!isEmpty(row.original.description) ? row.original.description : '-'}
            </div>
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Created Datetime',
      accessor: 'createdAt',
      width: 150,
      sortable: true,
      Cell: ({ row }: any) => {
        return (
          <TableBodyCellColumn>
            {!isEmpty(row.original.createdAt)
              ? moment(row.original.createdAt).format(DATE_FORMAT)
              : '-'}
          </TableBodyCellColumn>
        );
      },
    },
    {
      Header: 'Created By',
      accessor: 'createdBy',
      width: 150,
      sortable: true,
    },
    {
      Header: 'Sandbox Type',
      accessor: 'visibility',
      width: 120,
      sortable: true,
      center: true,
      Cell: ({ row }: any) => {
        return (
          <Display>
            {row.original.visibility ? (
              <Tag
                variant={
                  row.original.visibility === SandboxVisibility.Private
                    ? 'info'
                    : 'success'
                }
                title={row.original.visibility}
              />
            ) : (
              '-'
            )}
          </Display>
        );
      },
    },
    {
      Header: '',
      accessor: 'actions',
      width: 80,
      sortable: false,
      Cell: ({ row }: any) => {
        return (
          <div>
            {
              <ActionButton
                actions={tableActions}
                id={row.original.tenantId}
                rowData={row.original}
                counter={parseInt(row?.tenantId)}
              />
            }
          </div>
        );
      },
    },
  ];
};
